import { IoFlame } from "react-icons/io5";

type ProductCardPromoTimerProps = {
  text?: string
  expired?: boolean
}

export default function ProductCardPromoTimer({
  text,
  expired = false,
}: ProductCardPromoTimerProps) {
  if (!text) {
    return null
  }

  return (
    <div
      className={`inline-flex shrink-0 h-5.75 shrink-0 gap-1.5 items-center justify-center rounded-sm px-2 py-1 text-xs font-semibold leading-none ${
        expired
          ? 'bg-red-500 text-white'
          : 'bg-red-500/12 text-red-600'
      }`}
    >
      <IoFlame className="shrink-0" />
      {text}
    </div>
  )
}
